import React from 'react';
import { Select } from 'antd';

import TransactionsTable from './TransactionsTable';
import EntityBreakdownCard from '../../../../../../../shared/designSystem/components/EntityBreakdownCard';
import { MenuItemTextColor } from '../../../../../../../shared/globalStyling/styledText';
import {
  attributionWindowSelections,
  attributionTypeSelections,
} from '../../../../../../../../core/utils/constants/constants';

const { Option } = Select;

// =============================================================================
// TransactionDetails — unified Transactions section card (V2 tab).
//
// Structural mirror of Creatives / Publishers section cards on this tab.
// Owns the attribution window + attribution method Selects in the head —
// those control which transactions are counted, so they belong next to the
// table that shows them.
// =============================================================================

const TransactionDetails = ({
  transactions = [],
  transactionsPagination = { total: 0, hasNextPage: false },
  getImpressions,
  loading = false,
  attributionWindow = 30,
  changeAttributionWindow,
  attributionMethod = 'ALL',
  changeAttributionMethod,
}) => {
  return (
    <EntityBreakdownCard
      title="Transactions"
      controls={
        <div className="campaign-overview__attribution-controls">
          <label className="campaign-overview__attribution-field">
            <span className="campaign-overview__attribution-label mono-eyebrow">
              Attribution window
            </span>
            <Select
              value={attributionWindow}
              onChange={(val) => changeAttributionWindow(val)}
              getPopupContainer={(trigger) => trigger.parentNode}
              popupClassName="mjl-ds"
              className="campaign-overview__attribution-select"
              size="small"
            >
              {attributionWindowSelections.map((option) => (
                <Option key={option.key} value={option.key}>
                  <MenuItemTextColor text={option.name} />
                </Option>
              ))}
            </Select>
          </label>
          <label className="campaign-overview__attribution-field">
            <span className="campaign-overview__attribution-label mono-eyebrow">
              Method
            </span>
            <Select
              value={attributionMethod}
              onChange={(val) => changeAttributionMethod(val)}
              getPopupContainer={(trigger) => trigger.parentNode}
              popupClassName="mjl-ds"
              className="campaign-overview__attribution-select"
              size="small"
            >
              {attributionTypeSelections.map((option) => (
                <Option key={option.key} value={option.key}>
                  <MenuItemTextColor text={option.name} />
                </Option>
              ))}
            </Select>
          </label>
        </div>
      }
      loading={loading}
      table={
        <TransactionsTable
          transactionData={transactions}
          transactionsPagination={transactionsPagination}
          getImpressions={getImpressions}
        />
      }
    />
  );
};

export default TransactionDetails;
